// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.animText {
  font-family: Geometria, "Gill Sans", sans-serif;
  font-size: 47pt;
}`, "",{"version":3,"sources":["webpack://./src/components/AnimText/css/AnimText.css"],"names":[],"mappings":"AAAA;EACE,+CAA+C;EAC/C,eAAe;AACjB","sourcesContent":[".animText {\n  font-family: Geometria, \"Gill Sans\", sans-serif;\n  font-size: 47pt;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
